import { StyleSheet } from 'react-native';
import { spacing } from '../../theme';

export const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    borderRadius: 24,
    height: 48,
    justifyContent: 'center',
    width: 48,
  },
  hidden: {
    opacity: 0,
  },
  horizontalContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 16,
    width: '100%',
    flexWrap: 'wrap',
    rowGap: spacing[5],
  },
  main: {
    flexDirection: 'row',
    marginRight: spacing[3],
  },
  text: {
    fontSize: 18,
  },
});
